import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["carrier"];
  connect() {
    console.log("Hello from Stimulus JS");
  }

  onSelectCarrier(event) {
    const carrier_id = event.target.value;

    fetch(`/carriers/${carrier_id}.json`, {
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((data) => this.showData(data));
  }

  showData(data) {
    //console.log(data);
    var carrierHTML = "";
    carrierHTML += this.carrierTemplate(data);
    this.carrierTarget.innerHTML = carrierHTML;
  }

  carrierTemplate(carrier) {
    return `
        <h5 class="mb-3">carrier Details</h5>

        <div class="flex flex-col space-y-1 text-sm">
            <div>${carrier.street}</div>
            <div> ${carrier.city} ${carrier.state} ${carrier.zip}</div>
            <div>${carrier.contact_name}</div>
            <div>${carrier.phone}</div>
            <div>${carrier.contact_email}</div>
            <div>${carrier.contact_phone}</div>
            <div><a href="/carriers/${carrier.id}" target="_blank">Edit Carrier Details</a></div>
        </div>

    `;
  }
}
